export default __webpack_public_path__ + "static/media/emoji-stats.6cf5f880.svg";